<template>
  <div>
    <template v-if="visualizaExporta && permissao != null">
      <div class="mt-3 titlePage">Exportar Vagas Reservadas</div>
      <form @submit.prevent="exportarVagas" autocomplete="off">
        <div class="row mt-3">
          <div class="col-sm-8"><fcc-input v-model="exportar.titulo">Título</fcc-input></div>
          <div class="col-sm-4"><fcc-button type="submit">Exportar</fcc-button></div>
        </div>
      </form>
    </template>
    <fcc-modal
      centered
      id-modal="addStatusTestes"
      title-modal="Testes"
      esconde-footer
      trava-esc
      size="lg"
      trava-back
    >
      <FccTestesCandidato :baseUrlPublicacao="baseUrlPublicacao" :controlePage="controlePage" />
    </fcc-modal>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          :optionsButton="optionsButton"
          hover
          :fields="fieldsTecnico"
          :orderby="sortBy"
          :items="lstVagas"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
import FccTestesCandidato from './fccTestesCandidato.vue'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '5',
      visualizaExporta: false,
      lstVagas: [],
      exportar: {
        spi: '',
        cdFuncionario: '',
        titulo: 'Vagas Reservadas, Provas e Condições Específicas'
      },
      permissao: '',
      optionsButton: [
        {
          funcaoButton: 'testesField',
          tooltip: 'Testes',
          icon: 'user',
          text: 'Testes',
          variant: 'primary',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      fieldsTecnico: [
        {
          key: 'técnico',
          label: 'Técnico',
          sortable: true
        },
        { key: 'data da exportação', label: 'Data', sortable: true },
        { key: 'título', label: 'Título', sortable: true }
      ]
    }
  },
  components: { FccTestesCandidato },
  methods: {
    exportarVagas() {
      this.callConfirm('Deseja Exportar as vagas reservadas? ', '').then((result) => {
        if (result.value) {
          this.carregaTexto('Exportando...')
          axios
            .post(
              this.baseUrlPublicacao + 'Publicacao/ExportarVagasReservadas',
              this.exportar,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((resposta) => {
              if (resposta.data.inconsistencia != null) {
                const message = resposta.data.inconsistencia.reduce((acc, curr) => {
                  const ordemPostoMessage = acc + `Ordem: ${curr.ordem} - Posto: ${curr.posto}`

                  return curr.obs
                    ? ordemPostoMessage + ` - Observação: ${curr.obs} <br/>`
                    : ordemPostoMessage + '<br/>'
                }, '')

                this.callAlert('Erro na exportação', '', 'error', 'error', message)
              } else {
                this.callToast('Sucesso ao exportar')
                this.listarVagas()
              }
              this.carregaTexto()
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    testesField() {
      this.$root.$emit('bv::show::modal', 'addStatusTestes')
    },
    verificaStatus() {
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/StatusExportacao/' + this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data === 1) {
            this.$emit('exportaStatus', true)
            this.visualizaExporta = true
          } else {
            this.$emit('exportaStatus', false)
            this.visualizaExporta = false
          }
        })
        .catch(this.setErrorSystem)
    },
    listarVagas() {
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/ListaVagasReservadas?spi=' + this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstVagas = response.data.retorno
          this.verificaStatus()
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    baseUrlPublicacao: String
  },
  mounted() {
    this.listarVagas()
    this.exportar = {
      spi: this.controlePage.spi,
      cdFuncionario: this.dadosUserSession.usuCdFuncionario,
      titulo: 'Vagas Reservadas, Provas e Condições Específicas'
    }
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
  }
}
</script>
